import enUS from "./en-US.json";
import healthLegends from "./health-en-US.json";

const getMessages = (locale) => {
  return Object.assign({}, enUS, healthLegends);
};

export default getMessages;
